export enum MenuFooterLabels {
  PersonalDataProtection = 'Protection des données personnelles',
  LegalMentions = 'Mentions légales',
  CookiesPolicy = 'Politique en matière de cookies'
}

export enum MenuFooterPaths {
  PersonalDataProtection = 'https://www.lohmann-rauscher.com/fr-fr/protection-des-donnees/',
  LegalMentions = 'https://www.lohmann-rauscher.com/fr-fr/mentions-legales/',
  CookiesPolicy = 'https://www.lohmann-rauscher.com/fr-fr/protection-des-donnees/'
}
